Copyright 2022 Bio-Conversion Databank Foundation Licensed under the Apache
License, Version 2.0 (the "License"); you may not use this file except in
compliance with the License. You may obtain a copy of the License at
http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable law or
agreed to in writing, software distributed under the License is distributed on
an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
or implied. See the License for the specific language governing permissions and
limitations under the License

<template>
  <v-container class="my-16">
    <p class="mx-2 mt-4">
      We have sent a confirmation code to your email, enter the code below to
      continue
    </p>

    <v-form @submit.prevent="onConfirm" v-model="isFormValid">
      <v-text-field
        label="Confirmation code"
        v-model="code"
        data-testid="code"
        outlined
        clearable
        :rules="[validateIsNumber]"
      >
      </v-text-field>

      <v-btn
        elevation="0"
        data-testid="confirm"
        large
        color="primary"
        type="submit"
        :disabled="!isFormValid"
      >
        Confirm
      </v-btn>

      <p @click="onResend" class="my-8" data-testid="resend-code">
        <a href="#"> Resend code </a>
      </p>
    </v-form>
  </v-container>
</template>

<script>
import UserPool from '@/plugins/UserPool';
import { validateIsNumber } from '@/utilities/validationRules';
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';

export default {
  name: 'RegisterConfirm',
  props: {
    authDetails: AuthenticationDetails,
  },
  data() {
    return {
      // visual state
      showPassword: true,
      // registration data
      code: '',
      // error handling
      isFormValid: false,
    };
  },
  methods: {
    validateIsNumber,
    onConfirm() {
      let user = new CognitoUser({
        Username: this.authDetails.getUsername(),
        Pool: UserPool,
      });
      user.confirmRegistration(this.code, true, (err, data) => {
        if (err) {
          console.log(err); // DEBUG
          const notification = {
            type: 'error',
            message: err.message,
          };
          this.$store.dispatch('addNotification', notification);
        } else {
          console.log(data); // DEBUG

          // if user is not logging in, then that means they are registering
          if (this.$route.name !== 'Login') {
            // send user to configure MFA once confirmed registration
            this.$emit('toggle-on-mfa', this.authDetails);
            /*
            if (localStorage.getItem('rememberMe') == 'true') {
              localStorage.setItem('authenticated', 'true');
            } else {
              sessionStorage.setItem('authenticated', 'true');
            }
            this.$router.push({ name: 'Dashboard' });
            */
          } else {
            // emit confirmation to update the page and log user in
            this.$emit('toggle-on-confirm');
          }
        }
      });
    },
    onResend() {
      let user = new CognitoUser({
        Username: this.authDetails.getUsername(),
        Pool: UserPool,
      });

      user.resendConfirmationCode((err, data) => {
        if (err) {
          console.log(err); // DEBUG
          const notification = {
            type: 'error',
            message: err.message,
          };
          this.$store.dispatch('addNotification', notification);
        } else {
          console.log(data); // DEBUG
          const notification = {
            type: 'success',
            message: 'Confirmation code is resent',
          };
          this.$store.dispatch('addNotification', notification);
        }
      });
    },
  },
};
</script>
